import fetchGql from '~/utils/fetchGql'

const storyPathQuery = gql`
  query ContentNodeQuery($language: String, $uuid: ID!) {
    ContentNode(language: $language, find_by: "uuid", id: $uuid) {
      full_slug
    }
  }
`

const storyHeadingsQuery = gql`
  query ContentNodesQuery($startsWith: String, $slug: String) {
    ContentNodes(starts_with: $startsWith, by_slugs: $slug, per_page: 1) {
      items {
        content
      }
    }
  }
`

const parseStoryPathData = (data: any) => {
  return data.full_slug
}

const parseStoryHeadingsData = (data: any) => {
  const results: any[] = []

  data.items.forEach((story: any) => {
    story.content.body.forEach((block: any) => {
      if (block.component === 'heading' && block.anchorId) {
        results.push({ title: block.text, id: block.anchorId })
      }
    })
  })

  return results
}

export const useFetchStoryData = () => {
  const fetchStoryPath = async (language: string, uuid: string) => {
    const variables: any = {
      language,
      uuid
    }

    const value: any = await fetchGql(storyPathQuery, variables)
    const storyCMS: any = value.ContentNode

    return parseStoryPathData(storyCMS)
  }

  const fetchStoryHeadings = async (language: string, slug: string) => {
    const variables = {
      startsWith: (language === 'en' ? '' : `${language}/`) + 'careers/',
      slug: `*/${slug}/`
    }

    const value: any = await fetchGql(storyHeadingsQuery, variables)
    const storyCMS: any = value.ContentNodes

    return parseStoryHeadingsData(storyCMS)
  }

  return { fetchStoryPath, fetchStoryHeadings }
}
